import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BotFlowModule from '../pages/botFlow/BotFlowModule';
import FlowList from '../pages/botFlow/FlowList';
import FlowBuilder from '../pages/botFlow/FlowBuilder';

const BotFlowRoute = () => (
  <Routes>
    <Route element={<BotFlowModule />}>
      <Route index element={<FlowList />} />
      <Route path=":flowId" element={<FlowBuilder />} />
      <Route path="*" element={<Navigate to="/dashboard/bot-flow" replace />} />
    </Route>
  </Routes>
);

export default BotFlowRoute;
